import { LuLock } from "react-icons/lu";

import { CollectionIcon } from "@/components/shared/collection-icon";
import { TimestampTooltip } from "@/components/shared/timestamp-tooltip";
import type { CollectionMeta } from "@/hooks/use-collections";
import { pluralize } from "@/utils/helpers";

import { CollectionListItemManageButton } from "./collection-list-item-manage-button";

interface CollectionListItemProps {
  collection: CollectionMeta;
}

export function CollectionListItem({ collection }: CollectionListItemProps) {
  return (
    <div
      className="
        flex cursor-pointer items-center justify-between rounded-lg border p-4
        hover:border-primary hover:bg-accent
      "
    >
      <div className="flex items-center gap-4">
        <div
          className="
            flex size-10 shrink-0 items-center justify-center rounded-full
            border border-border bg-card/50
          "
        >
          <CollectionIcon
            type={collection.type}
            className="size-4 text-muted"
          />
        </div>
        <div className="flex flex-col gap-1">
          <h3
            className="
              flex items-center gap-2 font-sans text-sm font-semibold
              text-muted-foreground
            "
          >
            {collection.private && (
              <LuLock className="size-4 shrink-0 text-muted" />
            )}
            <span className="line-clamp-1 min-w-0 wrap-break-word">
              {collection.name}
            </span>
          </h3>
          {collection.description && (
            <p className="line-clamp-1 text-xs text-muted">
              {collection.description}
            </p>
          )}
        </div>
      </div>
      <div className="flex items-center gap-4">
        <div
          className="
            hidden flex-col items-end gap-1
            @mq-md:flex
          "
        >
          <span className="text-xs text-muted-foreground">
            {pluralize(collection.items.length, "item")} •{" "}
            <span className="capitalize">{collection.type}</span>
          </span>
          <span className="text-xs text-muted">
            <TimestampTooltip
              timestamp={collection.updatedAt}
              leadingText="Updated"
            />
          </span>
        </div>
        <div className="flex items-center gap-2">
          {collection.id && (
            <CollectionListItemManageButton collectionId={collection.id} />
          )}
        </div>
      </div>
    </div>
  );
}
